import React, {ReactNode} from 'react'
import styled from 'styled-components'
import PPSelect, {OptionProps} from '../../shared/forms/PPSelect'
import {FontSizeInPixel, FontWeights} from '../../../styledComponents/Constants'
import {Moment} from 'moment'
import {formatDateLocalSlashSeparator} from '../../../formatters/formatMoment'
import {PageMainArea} from '../../shared/hoc/withAdminPageTemplate'
import {Nullable} from '../../../app/TypeHelpers'
import {AssocOfCondominium} from '../model/AssocOfCondominium'

export const AssocItemName = styled.div`
  min-width: 96px;
`

export const AssocItemValue = styled.div`
  font-weight: ${FontWeights.Bold};
  font-size: ${FontSizeInPixel.Body}px;
  overflow-wrap: anywhere;
  line-break: anywhere;
`

export const TransparentSelect = styled(PPSelect)`
  &.MuiInputBase-root {
    background-color: initial;
    font-weight: 700;
  }

  .MuiSelect-root {
    background-color: initial;
  }

  .MuiSelect-select {
    min-width: 343px;
    font-weight: ${FontWeights.Bold};
    font-size: ${FontSizeInPixel.Body}px;
  }
`

export const FitPageMainArea = styled(PageMainArea)`
  width: fit-content;
`

export const NoWrapSpan = styled.span`
  display: inline-block;
  white-space: pre;
`

export const WidthBuffer = styled.div`
  max-height: 0;
  overflow: hidden;
  overflow-wrap: anywhere;
  white-space: normal;
`

export function formatTerm(startDate: Nullable<Moment>, endDate: Nullable<Moment>): string {
    if (!startDate && !endDate) {
        return ''
    }
    const startDateString = startDate ? formatDateLocalSlashSeparator(startDate) : ''
    const endDateString = endDate ? formatDateLocalSlashSeparator(endDate) : ''
    return `${startDateString} 〜 ${endDateString}`.trim()
}

export function makeTermNode(startDate: Nullable<Moment>, endDate: Nullable<Moment>): ReactNode {
    if (!startDate && !endDate) {
        return ''
    }
    const startDateString = startDate ? formatDateLocalSlashSeparator(startDate) : ''
    const endDateString = endDate ? formatDateLocalSlashSeparator(endDate) : ''
    if (!endDate) {
        return <NoWrapSpan>{startDateString} 〜</NoWrapSpan>
    }
    if (!startDate) {
        return <NoWrapSpan>〜 {endDateString}</NoWrapSpan>
    }
    return <>
        <NoWrapSpan>{startDateString} </NoWrapSpan>
        <NoWrapSpan>〜 {endDateString}</NoWrapSpan>
    </>
}

export function convertAssocListToAssocSelectList(assocList: AssocOfCondominium[]): OptionProps[] {
    const indent = '　'
    const childrenMap = new Map<number | null, AssocOfCondominium[]>()

    // 階層化
    assocList.forEach(item => {
        const key = item.parentAssocId
        if (!childrenMap.has(key)) {
            childrenMap.set(key, [])
        }
        childrenMap.get(key)!.push(item)
    })

    // ソート
    childrenMap.forEach((assoc) => {
        assoc.sort((a, b) => {
            return a.assocCd.localeCompare(b.assocCd, 'ja')
        })
    })

    const result: OptionProps[] = []

    const walk = (parentId: number | null, depth: number) => {
        const children = childrenMap.get(parentId) ?? []
        children.forEach(child => {
            result.push({
                label: indent.repeat(depth) + child.assocCd + '：' + child.assocName,
                value: String(child.assocId),
            })
            walk(child.assocId, depth + 1)
        })
    }

    walk(null, 0)

    return result
}
